import * as STATIC from '../config/static';
import _ from 'lodash';
function isInt(n) { return parseInt(n) === n };
export function randomQuestionList(number = 1,formular) {

  let questions = [];
  let { type, maxNumber, rows, digits,digits1,digits2,dr1,dr2,dba,roundNumber } = formular;
  if (!type) {
    alert("Please select type");
    return;
  }
  if (rows < 3 || rows > 100) {
    alert("Rows need to be between 3 and 100");
    return;
  }
  let index;
  for (index = 0; index < number; index++) {
    let item = { type: "image" };
    if (type.length > 0) {
      item = { type: _.sample(type) };
    //  item = { type: 'L&B_-9.2' };
    }
    if (item.type == "soroban") {
      item.result = _.random(Math.pow(10,digits-1),Math.pow(10,digits)-1);
    }
    else if (item.type == "image") {
      item.result = _.random(9);
      if(digits>1)
      {
        item.result = _.random(10,99);
        if(roundNumber)
        {
          item.result = _.random(1,9)*10;
        }
      }


      item.images = [];
      if (item.result >= 10) {
        item.images.push("assets/images/finger/" + Math.floor(item.result / 10) + "0-01.png");
      }
      if(item.result < 10||roundNumber==0||roundNumber==false)
      {
        item.images.push("assets/images/finger/" + item.result % 10 + "-01.png");
      }

    }
    else if(item.type=="multiple")
    {

      let d1 = _.random(Math.pow(10,digits1-1),Math.pow(10,digits1)-1);
      if(roundNumber)
      {
        d1 = _.random(1,9)*Math.pow(10,digits1-1);
      }
      let d2 = _.random(Math.pow(10,digits2-1),Math.pow(10,digits2)-1);
      if(roundNumber)
      {
        d2 = _.random(1,9)*Math.pow(10,digits2-1);
      }
      if(dr1!=0&&dr2!=0)
      {
        d2 = _.random(dr1,dr2);
      }

      item.numbers = [d1,"x"+d2];
       item.result = d1*d2;
    }
    else if(item.type=="divide")
    {
      let d1 = _.random(Math.pow(10,digits1-1),Math.pow(10,digits1)-1);
      if(roundNumber)
      {
        d1 = _.random(1,9)*Math.pow(10,digits1-1);
      }
      let d2 = _.random(Math.pow(10,digits2-1),Math.pow(10,digits2)-1);
      if(roundNumber)
      {
        d2 = _.random(1,9)*Math.pow(10,digits2-1);
      }
      if(dr1!=0&&dr2!=0)
      {
        d2 = _.random(dr1,dr2);
      }

      console.log(dba);
      if(parseInt(dba)==1)
      {

          let index=1;
          let nList =[];
          while (index)
          {
            if(d2*index<Math.pow(10,digits1)-1)
            {
              if(d2*index >=Math.pow(10,digits1-1))
              nList.push(d2*index);
              index++;
            }
            else {
              break;
            }
          }
        d1=_.sample(nList);
      }

      item.numbers = [d1,"÷"+d2];
       item.result = d1/d2;
    }

    else {
    //  console.log(item.type);
      let type = item.type.split('_');
      if (type.length > 1) {
        let fDigit = parseInt(type[1]);
        let fType = type[0];
        // if(fType=="LB")
        // {
        generateItemForLB2(item, fDigit, type[0],formular,roundNumber);
        //}
      }


    }
    //console.log(item.numbers,item.result);
    questions.push(item);
  }
  return questions;
}

export function checkLB(t, value) {
  t=t%10;
  if (t > 0 && t < 5 && value > 0 && value < 5 && t + value >= 5 && t + value < 10) {
    return true;
  }
  if (t >= 5 && t < 10 && t + value > 0 && t + value < 5 && value > -5) {
    return true;
  }
  return false;
}
export function checkBB(t, value,lessThan0) {
  if (t > 0 && (t % 10) + value >= 10) {
    return true;
  }
  if (lessThan0) {
    if (t >= 0 && t < 10 && t + value < 0) {
      return true;
    }
  }
  else {
    if (t >= 10 && (t % 10) + value < 0) {
      return true;
    }
  }

  return false;
}

function getNumbersForLB(t, lbNumb = 0, last = false,formular) {
  let index = -9;
  let relArr = [];
  //console.log(lbNumb);

  for (index; index < 10; index++) {

    if (last) {
      if (t + index >= 0) {
        relArr.push(index);
      }
      else
        continue;
    }
    if ((lbNumb > 0 && lbNumb < 5) || (lbNumb < 0 && lbNumb > -5)) {
      if (checkLB(t + index, lbNumb)) {
        relArr.push(index);
      }
      else {
        continue;
      }
    }
    else {
      relArr.push(index);
    }



  }
  return relArr;
}
function getNumbersList(t, lbNumb = 0, last = false, type = 'LB',formular) {
  let index = -9;
  let relArr = [];
  //console.log(lbNumb);

  for (index; index < 10; index++) {

    if (last) {
      if (t + index >= 0) {
        relArr.push(index);
      }
      else
        continue;
    }
    if (type == "LB" && ((lbNumb > 0 && lbNumb < 5) || (lbNumb < 0 && lbNumb > -5))) {
      if (checkLB(t + index, lbNumb)) {
        relArr.push(index);
      }
      else {
        continue;
      }
    }
    else
      if ((lbNumb > 0 && lbNumb < 10) || (lbNumb < 0 && lbNumb > -10)) {
        if (checkBB(t + index, lbNumb,formular.lessThan0)) {
          if (lbNumb > 5) {
            if (type == "BB") {
              if (!checkLB(t + index, (-10 + lbNumb))) {
                relArr.push(index);
              }
              else {
                continue;
              }
            }
            else {
              //console.log(10-lbNumb);
              if (checkLB(t + index, (-10 + lbNumb))) {
                relArr.push(index);
              }
              else {
                continue;
              }
            }
          }
          else if (lbNumb < -5) {
            if (type == "BB") {
              if (!checkLB(t + index, (10 + lbNumb))) {
                relArr.push(index);
              }
              else {
                continue;
              }
            }
            else {
              //console.log(t+index,(10-lbNumb));
              if (checkLB(t + index, (10 + lbNumb))) {
                relArr.push(index);
              }
              else {
                continue;
              }
            }
          }
          else {
            relArr.push(index);
          }
        }
        else {
          continue;
        }
      }

      else {
        relArr.push(index);
      }



  }
  return relArr;
}


function getFormulaList(type,formular) {
  let typeObject = _.find(STATIC.typeList,{value:type});
  let index = STATIC.LBFormulaList.findIndex(t=>t==typeObject.fvalue);
  if(formular.isReversed)
  {
    index = STATIC.LBFormulaList2.findIndex(t=>t==typeObject.fvalue);
  }
  //console.log(type,index);
  let relArr = [];
  if (index > -1) {
    for (let nIndex = 0; nIndex <= index; nIndex++) {
      if(formular.isReversed)
      {
        relArr.push(STATIC.LBFormulaList2[nIndex]);
      }
      else
      relArr.push(STATIC.LBFormulaList[nIndex]);
    }
  }

  return relArr;
}
// getRandomFormula(type) {
//   let index = typeList.findIndex(t => t.value == type);
//
//
//   let relArr = [];
//   if (index > -1) {
//     for (let nIndex = 0; nIndex < index; nIndex++) {
//       relArr.push(LBFormulaList[nIndex]);
//     }
//   }
//   if (relArr.length > 0) {
//
//     return _.sample(relArr);
//   }
//   return null;
// }

function filterNumbersWithList(total, list, numbers,formular) {
  let relArr = []
  for (let f of list) {
    let tArr = numbers.filter(n => {
      if (f == 0) {
        //  console.log('check',total,n,checkLB(total,n));

        //return !checkLB(total,n)&&!checkBB(total,n)&&total+n>=0&&n!=0;
        if (formular.digits > 1)
          return !checkLB(total, n) && !checkBB(total, n,formular.lessThan0) && total + n >= 0;
        return !checkLB(total, n) && !checkBB(total, n,formular.lessThan0) && total + n >= 0 && n != 0;
      }
      else {
        if (f < 5 && f > -5 && isInt(f)) {

          return checkLB(total, n) && n == f && !checkBB(total, n,formular.lessThan0);
        }
        else {

          return checkBB(total, n,formular.lessThan0) && n == parseInt(f);
        }

      }
      return false;
    })

    relArr = _.union(relArr, tArr);
  }
  return relArr;
}
function generateItemForLB2(item, lbNumb, type,formular,roundNumber) {
  console.log("roundNumber",roundNumber);
  let { maxNumber, rows, digits, lessThan0,largerThan } = formular;
  item.result = _.random(maxNumber - 1);
  item.numbers = [];
  let total = 0;
  let nIndex = 0;
  let nTotal = [];

  let position = _.random(1, rows - 1);
  if ((type == "BB"||type == "L&B") && ((lessThan0 && lbNumb == -1) || (!lessThan0 && lbNumb < 0)))
    position = _.random(2, rows - 1);

  let vposition = _.random(0, digits - 1);
  if((type=='BB'||type=='L&B')&&largerThan==0)
  {
    if(digits>=2)
    vposition = _.random(0, digits - 2);
  }
  if(roundNumber==1)
  {
    largerThan = 1;
    vposition = digits-1;
  }


  //console.log("position",position,vposition);
  let fArray = [];
  for(let rIndex=0;rIndex<digits;rIndex++)
  {
    fArray.push([]);
    nTotal.push(0);
  }


  for (let tIndex = 0; tIndex < rows; tIndex++) {
    if (position == tIndex) {
      fArray[0].push(lbNumb);
    }
    else
      fArray[0].push(0);
      for(let rIndex=1;rIndex<digits;rIndex++)
      {
        fArray[rIndex].push(0);
      }
  }
  //console.log(fArray[0]);
  let formulaList = getFormulaList(item.type,formular);
  //console.log(item.type,position);
  for (nIndex; nIndex < rows; nIndex++) {

    let rNumber = [];
    for(let rIndex=0;rIndex<digits;rIndex++)
    {
      rNumber.push(0);
    }

    let numbers = [];
    //let temp_nTotal = nTotal;
    let next = fArray[0][nIndex + 1] ? fArray[0][nIndex + 1] : 0;
    let next01=next;
    let next2 = fArray[0][nIndex + 2] ? fArray[0][nIndex + 2] : 0;
    let next02=next2;
    let current = fArray[0][nIndex];
  //  console.log("total",total,nIndex,next2);
    //console.log(next,next2,next3);
    if (current != 0) {

      numbers = [current];

    }
    else {
      if (next != 0) {
        numbers = getNumbersList(nTotal[0], next, 0, type,formular)
      }
      else {
        if (nIndex == rows - 1) {
          numbers = getNumbersList(nTotal[0], next, true, type,formular)
        }
        else {
          numbers = getNumbersList(nTotal[0], next, 0, type,formular)
        }

      }
    }
    //console.log(1,numbers);
    numbers = filterNumbersWithList(nTotal[0], formulaList, numbers,formular);
    //console.log(2,numbers);
    numbers = numbers.filter(n => {
      let tnumbers = getNumbersList(nTotal[0] + n, next2, 0, type,formular);

      tnumbers = filterNumbersWithList(nTotal[0] + n, formulaList, tnumbers,formular);
      //console.log(tnumbers);
      return tnumbers.length > 0 ? true : false;
      //return nTotal+n<5&&nTotal+n>=0&&nTotal+n>=-4-next2;
    })

    if (nIndex == 0) {
      numbers = numbers.filter(n => n > 0);
    }
    if((type=='BB'||type=='L&B')&&largerThan==0)
    {
        if(vposition==digits-2)
        {
          //console.log(nIndex,1,next,nTotal[0],numbers);

          if(next2!=0||next!=0)
          {
            //console.log("next",next2,next);
            if((total>80&&next2!=0)||(total>90&&next!=0))
            {
            //  console.log('test',numbers,nTotal[0]);
              numbers = numbers.filter(n => n<=0);
            //  console.log('test',numbers,nTotal[0]);
            }
            else {
            //  console.log('test1',numbers,nTotal[0]);
              numbers = numbers.filter(n => total+n<=(next2!=0?80:90));
            //  console.log('test1',numbers,nTotal[0]);
            }

          }
          else {
            //  console.log('test12',numbers,nTotal[0]);
            numbers = numbers.filter(n => (nTotal[0]+n)+(nTotal[vposition+1])*10<100||n<=0);
            //console.log('test12',numbers,nTotal[0]);
          }

        //  console.log(nIndex,2,next,nTotal[0],numbers);
        }
    //  numbers = numbers.filter(n => nTotal[0]+n <20);
    }

    rNumber[0] = _.sample(numbers);
    nTotal[0] += rNumber[0];
    for(let rIndex=1;rIndex<digits;rIndex++)
    {
      if(roundNumber==1)
      {
        rNumber[rIndex] = 0;
        nTotal[rIndex] += 0;
        continue;
      }
      numbers=[];
      let next = 0;
      let next2 = 0;
      let current = fArray[rIndex][nIndex];
      if (current != 0) {

        numbers = [current];

      }
      else {
        if (next != 0) {
          numbers = getNumbersForLB(nTotal[rIndex], next, 0, type,formular)
        }
        else {
          if (nIndex == rows - 1) {
            numbers = getNumbersForLB(nTotal[rIndex], next, true, type,formular)
          }
          else {
            numbers = getNumbersForLB(nTotal[rIndex], next, 0, type,formular)
          }

        }
      }
      numbers = filterNumbersWithList(nTotal[rIndex], formulaList, numbers,formular);
      numbers = numbers.filter(n => {
        let rel = true;
        if(rNumber[0]>0)
        {
          if(n<0)
          rel=false
        }
        else if(rNumber[0]<0)
        {
          if(n>0)
          rel=false
        }
        // for(let rIndex2=1;rIndex2<=rIndex;rIndex++)
        // {
        //   if(rNumber[0]>0)
        //   {
        //     if(rNumber[rIndex]<0)
        //     rel=false;
        //   }
        //   else if(rNumber[0]<0)
        //   {
        //     if(rNumber[rIndex]>0)
        //     rel=false;
        //   }
        // }
        return rel;

      })
      numbers = numbers.filter(n => {
        let tnumbers = getNumbersForLB(nTotal[rIndex] + n, next2, 0, type,formular);
        tnumbers = filterNumbersWithList(nTotal[rIndex] + n, formulaList, tnumbers,formular);
        //console.log(tnumbers);
        return tnumbers.length > 0 ? true : false;
        //return nTotal+n<5&&nTotal+n>=0&&nTotal+n>=-4-next2;
      })

      if (nIndex == 0) {
        numbers = numbers.filter(n => n > 0);
      }
    //  console.log(nTotal[rIndex],nTotal[rIndex-1]);
      if((type=='BB'||type=='L&B')&&largerThan==0&&digits==rIndex+1)
      {
        // if(vposition==rIndex-1)
        // {
        //  console.log(numbers,nTotal[rIndex-1],next01);
        if(next02!=0)
        {
        //  console.log("test2",numbers,rNumber[0]);
          numbers = numbers.filter(n => (nTotal[rIndex-1]+(nTotal[rIndex]+n)*10<80||n<=0));
          if(numbers.length>=2)
          {
            numbers = numbers.filter(n => n!=0);
          }
        //  console.log("test22",numbers);
        }
        else
        if(next01!=0)
        {
        //  console.log("test3",numbers,rNumber[0]);
          numbers = numbers.filter(n => (nTotal[rIndex-1]+(nTotal[rIndex]+n)*10<90||n<=0));
          if(numbers.length>=2)
          {
            numbers = numbers.filter(n => n!=0);
          }
        //  console.log("test32",numbers,rNumber[0]);
        }
        else
        {
          numbers = numbers.filter(n => (nTotal[rIndex-1]+next01+(nTotal[rIndex]+n)*10<100)||n<=0);
          if(numbers.length>=2)
          {
            numbers = numbers.filter(n => n!=0);
          }
        }

        //  console.log(numbers);
        //}
        //console.log('larger');
        // console.log("||||||||||||")
        // numbers = numbers.filter(n => {
        //   console.log(n,nTotal[rIndex-1],(nTotal[rIndex]+n)*10,nTotal[rIndex-1]+(nTotal[rIndex]+n)*10);
        //     console.log("-------")
        //   return nTotal[rIndex-1]+(nTotal[rIndex]+n)*10<100});
      //numbers = numbers.filter(n => nTotal[rIndex]+n <9);
      }
      rNumber[rIndex] = _.sample(numbers);
      nTotal[rIndex] += rNumber[rIndex];
    }

    // let temp_total=total-rNumber;
    // if(nIndex==rows-1)
    // {
    //   rNumber = total;
    // }
    // else
    // while(temp_total>=maxNumber||temp_total<=-maxNumber)
    // {
    //   rNumber = _.random(-maxNumber+1,maxNumber-1);
    //   temp_total=total-rNumber;
    // }
    // total=temp_total;
    let finalNumber = rNumber[0];
    //console.log(finalNumber,rNumber);
    if(digits>=2)
    {
      finalNumber = rNumber[0]*Math.pow(10,vposition);

      for(let rIndex=1;rIndex<digits;rIndex++)
      {
        if(rIndex-1<vposition)
        finalNumber += rNumber[rIndex]*Math.pow(10,rIndex-1);
        else {
          finalNumber += rNumber[rIndex]*Math.pow(10,rIndex);
        }
      }
    }

    // if (digits == 2) {
    //   finalNumber = rNumber2 * 10 + rNumber;
    //   if (vposition == 1)
    //     finalNumber = rNumber * 10 + rNumber2;
    //   //console.log(rNumber2,rNumber);
    // }
    // if (digits == 3) {
    //   finalNumber = rNumber3 * 100 + rNumber2 * 10 + rNumber;
    //   if (vposition == 1)
    //     finalNumber = rNumber3 * 100 + rNumber * 10 + rNumber2;
    //   if (vposition == 2)
    //     finalNumber = rNumber * 100 + rNumber3 * 10 + rNumber2;
    //   //console.log(rNumber2,rNumber);
    // }
    // if (digits == 4) {
    //   finalNumber = rNumber4 * 1000 + rNumber3 * 100 + rNumber2 * 10 + rNumber;
    //   if (vposition == 1)
    //     finalNumber = rNumber4 * 1000 +rNumber3 * 100 + rNumber * 10 + rNumber2;
    //   if (vposition == 2)
    //     finalNumber = rNumber4 * 1000 +rNumber * 100 + rNumber3 * 10 + rNumber2;
    //     if (vposition == 3)
    //       finalNumber = rNumber * 1000 +rNumber4 * 100 + rNumber3 * 10 + rNumber2;
    //   //console.log(rNumber2,rNumber);
    // }
    // if (digits == 5) {
    //   finalNumber = rNumber5 * 10000 +rNumber4 * 1000 + rNumber3 * 100 + rNumber2 * 10 + rNumber;
    //   if (vposition == 1)
    //     finalNumber = rNumber5 * 10000 +rNumber4 * 1000 + rNumber3 * 100 + rNumber * 10 + rNumber2;
    //   if (vposition == 2)
    //     finalNumber = rNumber5 * 10000 +rNumber4 * 1000 + rNumber * 100 + rNumber3 * 10 + rNumber2;
    //   if (vposition == 3)
    //     finalNumber = rNumber5 * 10000 +rNumber * 1000 + rNumber4 * 100 + rNumber3 * 10 + rNumber2;
    //     if (vposition == 4)
    //       finalNumber = rNumber * 10000 +rNumber5 * 1000 + rNumber4 * 100 + rNumber3 * 10 + rNumber2;
    //   //console.log(rNumber2,rNumber);
    // }
  //  console.log(finalNumber);
    if (finalNumber != undefined && !isNaN(finalNumber))
      item.numbers.push(finalNumber);
    else {
    //  console.log('undefined', nTotal);
      // item.numbers=[];
      // nIndex=-1;
      //  nTotal = 0;
      // nTotal2 = 0;
      return generateItemForLB2(item,lbNumb,type,formular,roundNumber);
      //item.numbers.push(finalNumber);
    }
    total += finalNumber;
  }
  item.result = total;
  //  console.log(total);
}

export function getQuestionEQ(question)
{
  let rel = '';
  if(question.type!="image"&&question.type!="soroban")
  {

    for(let num of question.numbers)
    {
      if(question.type!='multiple'&&question.type!='divide')
      {
        if(rel=='')
        {
          rel=num;
          continue;
        }
        else {
          rel += (num>=0?' + ':' - ')+Math.abs(num);
        }
      }
      else {
        if(rel=='')
        {
          rel+=num;
        }
        else {
          rel+=""+num;
        }
      }

    }
  }

  return rel;
}

export function getTypeName(type)
{
  let rel = "";
  let item = STATIC.typeList.find(t=>t.value==type)
  if(item)
  {
    rel = item.label;
  }
  return rel;
}
